import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./Navbar.css";
import logo from "../assets/logo.jpg";

const tabs = [
  { name: "Home", path: "/" },
  { name: "Courses", path: "/courses" },
  { name: "About", path: "/about" },
  {
    name: "Register",
    path: "https://forms.zohopublic.in/teamhrdevs1/form/CourseRegistrationForm/formperma/oiKX6sX7_NH-6Kk1EkojLP83Zt4KS3RVT0zlgVEqTNs",
    external: true,
  },
];

const SlideTabs = () => {
  const [position, setPosition] = useState({
    left: 0,
    width: 0,
    opacity: 0,
  });

  const location = useLocation();
  const navigate = useNavigate();

  return (
    <ul
      className="slide-tabs-container"
      onMouseLeave={() =>
        setPosition((prev) => ({ ...prev, opacity: 0 }))
      }
    >
      {/* LEFT: Logo */}
      <li className="logo-item" onClick={() => navigate("/")}>
        <img src={logo} alt="DevSkillz Logo" className="nav-logo" />
        <span className="company-name">DevSkillz PVT LTD</span>
      </li>

      {/* CENTER: Nav Links */}
      <li className="nav-center">
        {tabs.map((tab) => (
          <Tab
            key={tab.name}
            path={tab.path}
            external={tab.external}
            setPosition={setPosition}
            isActive={!tab.external && location.pathname === tab.path}
          >
            {tab.name}
          </Tab>
        ))}
      </li>

      {/* RIGHT: Spacer */}
      <li className="nav-spacer"></li>

      {/* Hover Indicator */}
      <motion.div
        className="cursor"
        animate={{
          left: position.left,
          width: position.width,
          opacity: position.opacity,
        }}
        transition={{ type: "spring", stiffness: 500, damping: 30 }}
      />
    </ul>
  );
};

const Tab = ({ children, path, external, setPosition, isActive }) => {
  const ref = useRef(null);

  return (
    <div
      ref={ref}
      className={`tab-item ${isActive ? "active" : ""}`}
      onMouseEnter={() => {
        if (!ref.current) return;
        const { offsetLeft, offsetWidth } = ref.current;
        setPosition({
          left: offsetLeft,
          width: offsetWidth,
          opacity: 1,
        });
      }}
    >
      {external ? (
        <a
          href={path}
          target="_blank"
          rel="noopener noreferrer"
        >
          {children}
        </a>
      ) : (
        <Link to={path}>{children}</Link>
      )}
    </div>
  );
};

export default SlideTabs;
